import _reject from 'lodash/reject';
import _isEmpty from 'lodash/isEmpty';
import { ErrorToast, generateVideoUrl } from '../utils/Utils';

export const sanitizeRichText = (text) => {
  const sanitizedContent = text
    .replace(/^(<p><br><\/p>\s*)+/g, '')
    .replace(/(\s*<p><br><\/p>)+$/g, '')
    .trim();
  return sanitizedContent;
};

export const getFormData = (data, checkedInstrList, storyType, thumbnailImg, originalAv = null, showExternalLink = false) => {
  const formData = new FormData();
  formData.append('title', data?.title);
  formData.append('description', data?.description);
  let linkValue = data?.avPreview || '';
  if (storyType === 'VIDEO' && originalAv && !_isEmpty(originalAv) && originalAv?.url === data?.avPreview) {
    linkValue = generateVideoUrl(originalAv);
  }
  formData.append(storyType === 'VIDEO' ? 'link' : 'articleLink', linkValue);
  formData.append('publishDate', data?.publishDate);
  formData.append('readingTime', data?.duration);
  formData.append('punchline', data?.punchLine);
  formData.append('type', storyType);
  if (thumbnailImg instanceof File) {
    formData.append('thumbnail', thumbnailImg);
  }
  if (data?.audioFile instanceof File && storyType === 'PODCAST') {
    formData.append('audioFile', data?.audioFile);
  }
  checkedInstrList.forEach((val) => formData.append('sourceIds', val));
  _reject(data?.planId, (plan) => plan.value === '*')?.forEach((plan) => {
    formData.append('planIds', plan.value);
  });
  formData.append('externalLinkEnabled', showExternalLink);
  formData.append('externalLinkTitle', data?.externalLinkTitle?.trim() || '');
  formData.append('externalLink', data?.externalLink || '');
  return formData;
};

export const validateForm = (data, thumbnailImg, storyType, checkedInstrList, isEdit = false, thumbnail = null, showExternalLink = false) => {
  const errors = [];
  let formIsValid = true;
  if (!data?.title) {
    formIsValid = false;
    errors.push('Please enter Title');
  }
  if (data?.title && data?.title?.length > 120) {
    formIsValid = false;
    errors.push('Title char limit is 120');
  }
  const descriptionText = data?.description
    ?.replace(/<[^>]*>/g, '') // remove HTML tags
    ?.trim();

  if (!descriptionText) {
    formIsValid = false;
    errors.push('Please enter description!');
  }
  if (data?.description) {
    const sanitizedContent = sanitizeRichText(data?.description);
    if (sanitizedContent?.length > 600) {
      formIsValid = false;
      errors.push('Description char limit is 600');
    }
  }

  if (isEdit) {
    if (!thumbnailImg && !thumbnail) {
      formIsValid = false;
      errors.push('Please enter image');
    }
  } else if (!thumbnailImg) {
    formIsValid = false;
    errors.push('Please enter image');
  }
  if (!data?.punchLine) {
    formIsValid = false;
    errors.push('Please enter punch line');
  }
  if (data?.punchLine && data?.punchLine?.length > 120) {
    formIsValid = false;
    errors.push('Punch line char limit is 120');
  }
  if (!data?.duration) {
    formIsValid = false;
    errors.push('Please enter duration');
  }
  if (storyType !== 'PODCAST') {
    if (storyType === 'VIDEO' && !data?.avPreview) {
      formIsValid = false;
      errors.push('Please enter link');
    }
  } else if (!data.audioFile) {
    formIsValid = false;
    errors.push('Please select audio file');
  }
  if (checkedInstrList?.length <= 0) {
    formIsValid = false;
    errors.push('Please select an instructor');
  }
  if (!data?.planId || data?.planId?.length === 0) {
    formIsValid = false;
    errors.push('Please select atleast one plan');
  }
  if (!data?.publishDate) {
    formIsValid = false;
    errors.push('Please select a publish date');
  }

  if (showExternalLink) {
    if (!data?.externalLinkTitle?.trim()) {
      formIsValid = false;
      errors.push('Please enter link title');
    } else if (data.externalLinkTitle.trim().length > 25) {
      formIsValid = false;
      errors.push('Link title char limit is 25');
    }
    if (!data?.externalLink?.trim()) {
      formIsValid = false;
      errors.push('Please enter external link');
    }
  }

  if (errors.length !== 0) {
    ErrorToast(errors[0]);
  }
  return formIsValid;
};

export const getSelectedInstructorDetails = (checkedInstrList, instrlist) => {
  const selected = checkedInstrList?.map((item) => instrlist?.find((instr) => instr.id === item));
  const images = selected?.flatMap((sel) => sel?.thumbnail).filter(Boolean);
  const name = selected?.flatMap((sel) => sel?.name).filter(Boolean);
  const ids = selected?.flatMap((sel) => sel?.id).filter(Boolean);
  let text = '';
  if (name && name.length > 0) {
    text = name.length === 1 ? name[0] : `${name[0]} and ${name.length - 1} others`;
  }

  return { images, text, ids };
};
